import { FormSectionHandler } from '../entity.handler';
import { CostCentreResponse, IdName, CostCentreUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    parent?: IdName;
}


export class CostCentreDetailsSectionHandler implements FormSectionHandler<CostCentreResponse, EditorValues> {

    type = 'form';
    icon = ICONS.costcentre;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService,
        private creating: boolean
    ) {
    }

    private properties = ['name', 'parent'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.COSTCENTRE.DETAILS.${key}`, values);
    }

    applyUpdate(entity: CostCentreResponse, payload: CostCentreUpdateRequest): Promise<CostCentreResponse> {
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.updateCostCentre(entity.id, payload));
    }

    mapEntityToEditor(entity: CostCentreResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: CostCentreUpdateRequest, values: EditorValues): Promise<CostCentreUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: CostCentreResponse): Promise<FormBuilderField[]> {
        return this.grouping.getCostCentres(this.ownerId).then(assetGroups => {
            return [
                this.creating || entity.parent ? ComboField('parent', this.translate('FIELDS.PARENT'), true, EntityUtils.treeToComboValues(assetGroups), IdNameComboValueHandlers) : null,
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ].filter(x => x);
        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
